import { render, staticRenderFns } from "./DetailsPolicy.vue?vue&type=template&id=dc397f64"
import script from "./DetailsPolicy.vue?vue&type=script&lang=js"
export * from "./DetailsPolicy.vue?vue&type=script&lang=js"
import style0 from "./DetailsPolicy.vue?vue&type=style&index=0&id=dc397f64&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports